import Link from 'next/link';
import { useLog } from 'components/Navbar/Desktop/useNavBarClickLog';
import autolistLogoRed from 'public/static/images/autolist-logo-red.png';

export function AutolistLogo(): JSX.Element {
  const log = useLog();

  return (
    <>
      <Link href="/" legacyBehavior prefetch={false}>
        <a
          data-testid="logo"
          onClick={(): void => {
            log('autolist_icon_tap');
          }}
          className="logo"
        />
      </Link>
      <style jsx>{`
        .logo {
          display: inline-block;
          width: 137px;
          height: 20px;
          background-image: url('${autolistLogoRed}');
          background-size: 137px 20px;
          background-repeat: no-repeat;
        }
      `}</style>
    </>
  );
}
